import ChartTab from "./ChartTab";
import React from "react";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";

class ChartProductTabPure extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <ChartTab
        {...this.props}
        data={data}
        // defaultPageSize={computeDefaultTableSize(data, "article.name")}
        defaultPageSize={computeDefaultTableSize(data, "category.name")}
        pivots={["category", "product", "tiers", "seller"]}
        showColumns={["category", "product", "tiersAsClient", "seller"]}
        showPagination={false}
        showDetails={true}
        showExtra={true}
        defaultSorted={[
          {
            id: "category",
            desc: false
          }
        ]}
      />
    );
  }
}

export default ChartProductTabPure;
